enum ManagerStatus {
  SUSPENDED = "SUSPENDED",
  ACTIVE = "ACTIVE",
}
export default ManagerStatus;
